module.exports = "/* .form-group label{\r\n    color: #0000ff;    \r\n    font-size: 16px;\r\n    font-weight: normal\r\n} */\r\n\r\n.form-group p{\r\n    color: black;    \r\n}\r\n\r\n.form-group p:hover{\r\n    text-decoration: none;\r\n}\r\n\r\n.inside-content{\r\n    padding: 15px 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Main/contact-us-page/contact-us-page.component.css
// module id = ./src/app/pages/Main/contact-us-page/contact-us-page.component.css
// module chunks = main